import Vue from 'vue'
import { getUrl } from './get-url.js'

export default {
    get: function () {
        return Vue.http.get(getUrl('/videos'))
    }
}



// WEBPACK FOOTER //
// ./src/services/videos.js